import React from 'react';

import PropTypes from 'prop-types';

const InformationAlertTitle = ({ children }) => (
  <div className="information-alert__content__title">{children}</div>
);

InformationAlertTitle.propTypes = {
  children: PropTypes.node
};

export default InformationAlertTitle;
